module.exports = __webpack_public_path__ + "img/withdrawal-grey.dda22ee9.svg";